import HttpRequest from '@/utils/axios'
import config from '@/config'
let nodeEnv = process.env.NODE_ENV;//当前环境
let vueEnv=process.env.VUE_APP_ENV
// const baseUrl = process.env.NODE_ENV === 'development' ? config.baseUrl.dev : config.baseUrl.test
let baseUrl = nodeEnv === 'development' ?  config.baseUrl.dev : vueEnv === 'test' ?config.baseUrl.test : config.baseUrl.pro;
const axios = new HttpRequest(baseUrl)
export default axios
